<template>
  <div>
    <div class="decorative-divider"></div>

    <div class="bank-details" v-if="bankAccountDetails">
      <h2>Payment details</h2>
      <p v-if="bankAccountDetails['Bank Name']"><strong>Bank Name:</strong> {{bankAccountDetails['Bank Name']}}</p>
      <p v-if="bankAccountDetails['Account Name']"><strong>Account Name:</strong> {{bankAccountDetails['Account Name']}}</p>
      <p v-if="bankAccountDetails['BSB']"><strong>BSB:</strong> {{bankAccountDetails['BSB']}}</p>
      <p v-if="bankAccountDetails['IBAN']"><strong>IBAN:</strong> {{bankAccountDetails['IBAN']}}</p>
      <p v-if="bankAccountDetails['Account Number']"><strong>Account Number:</strong> {{bankAccountDetails['Account Number']}}</p>
      <p v-if="bankAccountDetails['SWIFT']"><strong>SWIFT/BIC:</strong> {{bankAccountDetails['SWIFT']}}</p>
      <p v-if="bankAccountDetails['Bank Address']"><strong>Bank Address:</strong> {{bankAccountDetails['Bank Address']}}</p>
      <p><strong>Reference:</strong> PS{{ booking.id | padded('0', 5) }}</p>
    </div>

    <div class="text-center">
      <ladda-button
        class="btn btn-payment"
        type="submit"
        :click="handlePaymentSentCallback"
        v-if="selectedPaymentAmountsAreNotSent">
        <i class="fa fa-send"></i> Payment Sent
      </ladda-button>
    </div>

    <ul class="large-checklist" v-if="$userIsAdmin">
      <li>
        <div class="checkbox checkbox-primary">
          <input type="checkbox" id="checkbox_payment_received" :disabled="processingPaymentsReceived" @click="handlePaymentReceivedCallback">
          <label for="checkbox_payment_received">
            Payment Received
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { helpers } from 'mixins/bookings'
import { http, notify } from 'utils'

export default {
  mixins: [helpers],

  props: {
    paymentIds: {
      required: true,
      type: Array
    }
  },

  data () {
    return {
      processingPaymentsReceived: false,
      bankAccountDetails: false
    }
  },

  computed: {
    ...mapState('booking', ['booking']),

    /**
     * Determines if we have selected both payment amounts.
     *
     * @return bool
     */
    selectedBothPaymentAmounts () {
      return this.paymentIds.length === 2
    },

    /**
     * Determines if the payment amounts selected are not sent.
     *
     * @return bool
     */
    selectedPaymentAmountsAreNotSent () {
      return this.paymentIds.some((id) => {
        if (this.bookingPaymentFull && parseInt(id) === this.bookingPaymentFull.id && (this.bookingPaymentFullIsUnpaid || this.bookingPaymentFullIsPending)) {
          return true
        }

        if (this.bookingPaymentDeposit && parseInt(id) === this.bookingPaymentDeposit.id && (this.bookingPaymentDepositIsUnpaid || this.bookingPaymentDepositIsPending)) {
          return true
        }

        if (this.bookingPaymentFinal && parseInt(id) === this.bookingPaymentFinal.id && (this.bookingPaymentFinalIsUnpaid || this.bookingPaymentFinalIsPending)) {
          return true
        }

        return false
      })
    }
  },
  created () {
    this.getBankDetails()
  },
  methods: {
    ...mapActions('payment', ['updatePaymentSent', 'updatePaymentReceived']),
    ...mapActions('booking', ['setBookingProperty']),
    getBankDetails () {
      return http.get('settings/bank-details/' + this.booking.region.shortname)
        .then((response) => {
          this.bankAccountDetails = response.data
        })
    },

    /**
     * Handle marking payments as sent.
     *
     * @return Promise
     */
    handlePaymentSentCallback () {
      const payload = {
        payments: this.paymentIds,
        payment_method: 'bank_transfer'
      }

      return this.updatePaymentSent({ bookingId: this.booking.id, payload })
        .then((response) => {
          this.setBookingProperty({ property: 'payments', value: response.data })

          if (this.selectedBothPaymentAmounts) {
            notify.success('Payments were successfully marked as sent.')
          } else {
            notify.success('Payment was successfully marked as sent.')
          }
        })
    },

    /**
     * Handle marking payments as received.
     *
     * This is potentially dangerous as it cannot be undone through UI.
     *
     * @return Promise
     */
    handlePaymentReceivedCallback () {
      if (this.processingPaymentsReceived) {
        return
      }

      this.processingPaymentsReceived = true

      const payload = {
        payments: this.paymentIds,
        payment_method: 'bank_transfer'
      }

      return this.updatePaymentReceived({ bookingId: this.booking.id, payload })
        .then((response) => {
          this.processingPaymentsReceived = false

          this.setBookingProperty({ property: 'payments', value: response.data })
        })
    }
  }
}
</script>
